<template>
	<div class="ptc-testconfig-maincontainer d-flex">
		<div class="testconfig-leftcontainer ptc-disable-class relativeclass">
			<div class="d-flex">
				<img
					src="../../assets/icons/Reports/bckarrow.svg"
					alt=""
					class="mr-1 pointer"
					@click="goToConfig()"
				/>
				<div class="testconfig-headtext heading ml-3">Configure Test</div>
			</div>
			<div class="test-section-tabs mt-3">
				<b-tabs v-model="tabIndex" content-class="mt-2">
					<b-tab>
						<template #title>
							<div class="d-flex align-items-center position-relative">
								<div>Opening Screen Display</div>
								<div
									style="position: absolute; top: 0px; right: -21px"
									v-if="testinstruction == 'not_accepted'"
									v-b-popover.hover.top.v-danger="{
										content: 'Please fill all the details',
									}"
									variant="primary"
								>
									<img
										v-if="
											dirtyCheckDescQuestion ||
												$v.testConfigData.config.testOrg.$error ||
												($v.testConfigData.config.testDesc.$error &&
													dirtyCheckDescQuestion)
										"
										src="../../assets/deletepopupicon.svg"
										alt=""
									/>
								</div>
							</div>
						</template>
						<div class="ptc-tabs-overflow pr-2 ptc-question-behaviour">
							<b-row>
								<b-col>
									<div class="topDiv mt-3">
										<label class="testconfigfieldsetStyle"
											>Configuration Name &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="ptc-testconfiginputField pr-35"
											type="text"
											placeholder="Enter here"
											@keyup="changeconfig()"
											v-model.trim="$v.configName.$model"
											:class="{ error: $v.configName.$error }"
										>
										</b-form-input>

										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="$v.configName.$dirty && !$v.configName.required"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>

										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="!$v.configName.maxLength && $v.configName.required"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 128 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col>
									<div class="topDiv mt-3 relativeclass">
										<label class="testconfigfieldsetStyle"
											>Test Organiser &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="ptc-testconfiginputField pr-35"
											type="text"
											placeholder="Enter here"
											@keyup="changeconfig()"
											v-model.trim="$v.testConfigData.config.testOrg.$model"
											:class="{
												error: $v.testConfigData.config.testOrg.$error,
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.testOrg.$dirty &&
													!$v.testConfigData.config.testOrg.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.testOrg.maxLength &&
													$v.testConfigData.config.testOrg.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 128 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<div class="topDiv mt-3 relativeclass">
										<div
											:class="
												dirtyCheckDescQuestion ||
												(!$v.testConfigData.config.testDesc.maxLength &&
													!dirtyCheckDescQuestion)
													? 'error'
													: ''
											"
										>
											<label class="testconfigfieldsetStyle"
												>Test Description&nbsp;<span class="asterik"
													>*</span
												></label
											>

											<QuillEditor
												:addquesProp="addques1"
												:value="$v.testConfigData.config.testDesc.$model"
												@validationVal="validateText"
												@questionText="updateQuestionContent"
												@addquesBack="changedaddQues"
												@keyup="changeconfig()"
											>
											</QuillEditor>
										</div>

										<div
											style="position: absolute; top: 8px; right: 12px"
											v-if="
												dirtyCheckDescQuestion &&
													$v.testConfigData.config.testDesc.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 8px; right: 12px"
											v-if="
												!$v.testConfigData.config.testDesc.maxLength &&
													!dirtyCheckDescQuestion
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 10024 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 8px; right: 12px"
											v-if="
												dirtyCheckDescQuestion &&
													!$v.testConfigData.config.testDesc.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>

							<b-row>
								<b-col>
									<div class="d-flex position-relative mt-3">
										<span class="radio-btn-label-14">Test</span>
										<b-form-radio-group
											class="ml-3"
											:options="testoptions"
											v-model="testConfigData.config.test"
											:disabled="groupType == 'I'"
											value-field="item"
											text-field="name"
											disabled-field="notEnabled"
											@change="changeconfig()"
											size="sm"
											:id="groupType == 'I' ? 'private-popover' : ''"
										></b-form-radio-group>
										<b-popover
											id="individual-popover"
											target="private-popover"
											triggers="click"
											variant="warning"
										>
											<img
												src="../../assets/icons/Qpbuilder/warning.svg"
												alt=""
											/>
											You cannot set a test as public for Individual Candidate
										</b-popover>
									</div>
								</b-col>
								<b-col> </b-col>
							</b-row>
						</div>

						<div class="mt-5 ptc-next">
							<b-button @click="openscreeen" class="addbtn pr-4 pl-4"
								>Next</b-button
							>
						</div>
						<div class="mt-5 ptc-undo">
							<div
								@click="$bvModal.show('confirm-undo')"
								v-if="configurechange"
								variant="outline"
								class="qb-add-more-matches pointer ml-3 pl-4 pr-4 mb-2"
							>
								undo changes
							</div>
						</div>
						<!-- Remove when above cod is used -->
					</b-tab>
					<!-- <b-tab v-if="testConfigData.config.payment">
            <template #title>
              <div class="d-flex align-items-center position-relative">
                <div>Payment</div>
              </div>
            </template>
            <div class="ptc-tabs-overflow pr-2 ptc-question-behaviour">
              <b-row>
                <b-col>
                  <div class="topDiv mt-3 relativeclass">
                    <label class="testconfigfieldsetStyle"
                      >Cost&nbsp;<span class="asterik">*</span></label
                    >
                    <b-form-input
                      class="ptc-testconfiginputField"
                      id="input-1"
                      placeholder="Enter here"
                      type="text"
                      @keyup="changeconfig()"
                      v-model.trim="
                        $v.testConfigData.config.paymentDetails.cost.$model
                      "
                      :class="{
                        error:
                          $v.testConfigData.config.paymentDetails.cost.$error,
                      }"
                    ></b-form-input>
                    <div
                      style="position: absolute; top: 5px; right: 12px"
                      v-if="
                        $v.testConfigData.config.paymentDetails.cost.$dirty &&
                        !$v.testConfigData.config.paymentDetails.cost.required
                      "
                      v-b-popover.hover.top.v-danger="{ content: 'Required' }"
                      variant="primary"
                    >
                      <img src="../../assets/deletepopupicon.svg" alt="" />
                    </div>
                  </div>
                </b-col>
                <b-col> </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="topDiv mt-3 relativeclass">
                    <label class="testconfigfieldsetStyle"
                      >About&nbsp;<span class="asterik">*</span></label
                    >
                    <ckeditor
                      v-model="
                        $v.testConfigData.config.paymentDetails.about.$model
                      "
                      :config="editorConfig"
                      :class="{
                        error:
                          $v.testConfigData.config.paymentDetails.about.$error,
                      }"
                    ></ckeditor>
                    <div
                      style="position: absolute; top: 5px; right: 12px"
                      v-if="
                        $v.testConfigData.config.paymentDetails.about.$dirty &&
                        !$v.testConfigData.config.paymentDetails.about.required
                      "
                      v-b-popover.hover.top.v-danger="{ content: 'Required' }"
                      variant="primary"
                    >
                      <img src="../../assets/deletepopupicon.svg" alt="" />
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <div class="topDiv mt-3 relativeclass">
                    <label class="testconfigfieldsetStyle"
                      >Skills Gain&nbsp;<span class="asterik">*</span></label
                    >
                    <ckeditor
                      v-model="
                        $v.testConfigData.config.paymentDetails.skillsGain
                          .$model
                      "
                      :config="editorConfig"
                      :class="{
                        error:
                          $v.testConfigData.config.paymentDetails.skillsGain
                            .$error,
                      }"
                    ></ckeditor>
                    <div
                      style="position: absolute; top: 5px; right: 12px"
                      v-if="
                        $v.testConfigData.config.paymentDetails.skillsGain
                          .$dirty &&
                        !$v.testConfigData.config.paymentDetails.skillsGain
                          .required
                      "
                      v-b-popover.hover.top.v-danger="{ content: 'Required' }"
                      variant="primary"
                    >
                      <img src="../../assets/deletepopupicon.svg" alt="" />
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="topDiv mt-3 relativeclass">
                    <label class="testconfigfieldsetStyle"
                      >What To Learn&nbsp;<span class="asterik">*</span></label
                    >
                    <ckeditor
                      v-model="
                        $v.testConfigData.config.paymentDetails.toLearn.$model
                      "
                      :config="editorConfig"
                      :class="{
                        error:
                          $v.testConfigData.config.paymentDetails.toLearn
                            .$error,
                      }"
                    ></ckeditor>
                    <div
                      style="position: absolute; top: 5px; right: 12px"
                      v-if="
                        $v.testConfigData.config.paymentDetails.toLearn
                          .$dirty &&
                        !$v.testConfigData.config.paymentDetails.toLearn
                          .required
                      "
                      v-b-popover.hover.top.v-danger="{ content: 'Required' }"
                      variant="primary"
                    >
                      <img src="../../assets/deletepopupicon.svg" alt="" />
                    </div>
                  </div>
                </b-col>
                <b-col> </b-col>
              </b-row>
              <b-row>
                <b-col class="ptc-checkBox">
                  <b-form-checkbox
                    class="mt-3 checkbox testconfig-checkbox"
                    size="sm"
                    name="checkbox-1"
                    v-model="testConfigData.config.paymentDetails.certificate"
                    @change="changeconfig()"
                  >
                    <div class="">Certificate Provided</div>
                  </b-form-checkbox>
                </b-col>
                <b-col class="ptc-checkBox">
                  <b-form-checkbox
                    class="mt-3 checkbox testconfig-checkbox"
                    size="sm"
                    name="checkbox-1"
                    v-model="testConfigData.config.paymentDetails.badge"
                    @change="changeconfig()"
                  >
                    <div class="">Badge Provided</div>
                  </b-form-checkbox>
                </b-col>
                <b-col class="ptc-checkBox">
                  <b-form-checkbox
                    class="mt-3 checkbox testconfig-checkbox"
                    size="sm"
                    name="checkbox-1"
                    v-model="testConfigData.config.paymentDetails.training"
                    @change="changeconfig()"
                  >
                    <div class="">Training Provided</div>
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </div>
            <div class="mt-5 ptc-next">
              <b-button @click="payment" class="addbtn pl-4 pr-4"
                >Next</b-button
              >
            </div>
            <div class="mt-5 ptc-undo">
              <div
                @click="$bvModal.show('confirm-undo')"
                v-if="configurechange"
                variant="outline"
                class="qb-add-more-matches pointer ml-3 pl-4 pr-4 mb-2"
              >
                undo changes
              </div>
            </div>
          </b-tab> -->
					<b-tab>
						<template #title>
							<div class="d-flex align-items-center position-relative">
								<div>Question Behaviour</div>
								<div
									style="position: absolute; top: 0px; right: -21px"
									v-b-popover.hover.top.v-danger="{
										content: 'Please fill all the details',
									}"
									variant="primary"
								>
									<img
										v-if="
											$v.testConfigData.config.passingPercentage.$error ||
												(($v.testConfigData.config.negativeMarkValue.$error ||
													$v.testConfigData.config.quesPerScreen.$error ||
													$v.testConfigData.config.buffertime.$error) &&
													$route.query.type != '4') ||
												$v.testConfigData.config.timebnsel.$error ||
												$v.testConfigData.config.timebnvalue.$error ||
												$v.testConfigData.config.maxnoattempts.$error ||
												$v.testConfigData.config.testDuration.$error ||
												$v.testConfigData.config.openTestdt.$error ||
												$v.testConfigData.config.closeTestdt.$error
										"
										src="../../assets/deletepopupicon.svg"
										alt=""
									/>
								</div>
							</div>
						</template>

						<div class="ptc-tabs-overflow pr-2 ptc-question-behaviour">
							<b-row>
								<b-col>
									<div class="topDiv mt-4 relativeclass">
										<label class="testconfigfieldsetStyle"
											>Test Duration (Minutes)&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="ptc-testconfiginputField pr-35"
											id="input-1"
											placeholder="Enter duration in minutes"
											type="text"
											@keyup="changeconfig()"
											@keypress="validateInput($event)"
											v-model="$v.testConfigData.config.testDuration.$model"
											:class="{
												error: $v.testConfigData.config.testDuration.$error,
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.testDuration.$dirty &&
													!$v.testConfigData.config.testDuration.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.testDuration.alpha &&
													$v.testConfigData.config.testDuration.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Enter a valid value',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.testDuration.between &&
													$v.testConfigData.config.testDuration.required
											"
											v-b-popover.hover.top.v-danger="{
												content:
													this.$route.query.type == '4'
														? 'Should be between 5 to 1440'
														: 'Should be between 5 to 360',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col>
									<div class="topDiv relativeclass mt-4">
										<label class="testconfigfieldsetStyle"
											>Passing Percentage&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											placeholder="Enter here"
											class="ptc-testconfiginputField pr-35"
											id="input-1"
											type="text"
											v-model.trim="
												$v.testConfigData.config.passingPercentage.$model
											"
											@keypress="validateInput($event)"
											@keyup="changeconfig()"
											:class="{
												error:
													$v.testConfigData.config.passingPercentage.$error,
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.passingPercentage.$dirty &&
													!$v.testConfigData.config.passingPercentage.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.passingPercentage.numeric &&
													$v.testConfigData.config.passingPercentage.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Enter a valid number',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.passingPercentage.between &&
													$v.testConfigData.config.passingPercentage.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 1 to 100',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<div class="topDiv mt-3 relativeclass fordatetime">
										<label class="testconfigfieldsetStyle"
											>Start Test Date & Time &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<datetime
											placeholder="Select Start date & time"
											ref="startDate"
											class="ptc-testconfiginputField"
											type="datetime"
											:min-datetime="startdatetime"
											use12-hour
											v-model="testConfigData.config.openTestdt"
											:class="{
												error:
													$v.testConfigData.config.openTestdt.$error ||
													timeDiffMinutes,
											}"
										></datetime>
										<img
											@click="focusOnStartDate()"
											class="calender-image pointer"
											src="../../assets/calendar.svg"
											alt=""
										/>
									</div>
									<div
										style="position: absolute; top: 20px; right: 48px"
										v-if="
											$v.testConfigData.config.openTestdt.$dirty &&
												!$v.testConfigData.config.openTestdt.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</b-col>
								<b-col>
									<div class="topDiv mt-3 relativeclass fordatetime">
										<label class="testconfigfieldsetStyle"
											>End Test Date & Time&nbsp;<span class="asterik">*</span>
										</label>
										<div class="dt">
											<datetime
												:disabled="testConfigData.config.openTestdt === ''"
												ref="endDate"
												placeholder="Select End date & time"
												class="ptc-testconfiginputField"
												type="datetime"
												use12-hour
												:min-datetime="minDate"
												v-model="testConfigData.config.closeTestdt"
												:class="{
													error:
														$v.testConfigData.config.closeTestdt.$error ||
														timeDiffMinutes,
												}"
											></datetime>
											<img
												@click="focusOnEndDate()"
												class="calender-image pointer"
												src="../../assets/calendar.svg"
												alt=""
											/>
										</div>
									</div>
									<div
										style="position: absolute; top: 20px; right: 48px"
										v-if="
											$v.testConfigData.config.closeTestdt.$dirty &&
												!$v.testConfigData.config.closeTestdt.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</b-col>
							</b-row>
							<div
								class="testtime-warning-box p-1 mt-1"
								style="width: 50%; margin-top: 10px; padding: 8px"
								v-if="timeDiffMinutes"
							>
								<img src="../../assets/testtimewarning.svg" alt="" />

								The start and end time & date cannot be less than the test
								duration.
							</div>
							<b-row>
								<b-col v-if="$route.query.type != '4'">
									<div class="topDiv mt-3 relativeclass">
										<label class="testconfigfieldsetStyle"
											>Number Of Questions Per Screen&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="ptc-testconfiginputField pr-35"
											id="input-1"
											placeholder="Enter here"
											type="text"
											@keyup="changeconfig()"
											@keypress="validateInput($event)"
											v-model.trim="
												$v.testConfigData.config.quesPerScreen.$model
											"
											:class="{
												error:
													$v.testConfigData.config.quesPerScreen.$error &&
													$route.query.type != '4',
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.quesPerScreen.$dirty &&
													!$v.testConfigData.config.quesPerScreen.required &&
													$route.query.type != '4'
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.quesPerScreen.between &&
													$v.testConfigData.config.quesPerScreen.numeric &&
													$route.query.type != '4'
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 1 to 10',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col v-if="$route.query.type != '4'">
									<div class="topDiv mt-3 relativeclass">
										<label class="testconfigfieldsetStyle"
											>Specify Negative Marks&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											placeholder="Enter here"
											class="ptc-testconfiginputField pr-35"
											id="input-1"
											type="text"
											@keyup="changeconfig()"
											@keypress="validateInput($event)"
											v-model.trim="
												$v.testConfigData.config.negativeMarkValue.$model
											"
											:class="{
												error:
													$v.testConfigData.config.negativeMarkValue.$error &&
													$route.query.type != '4',
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.negativeMarkValue.$dirty &&
													!$v.testConfigData.config.negativeMarkValue
														.required &&
													$route.query.type != '4'
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.negativeMarkValue.numeric &&
													$v.testConfigData.config.negativeMarkValue.required &&
													$route.query.type != '4'
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Enter a valid number',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.negativeMarkValue.between &&
													$v.testConfigData.config.negativeMarkValue.numeric
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 0 to 30',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<div class="topDiv mt-3 relativeclass">
										<label class="testconfigfieldsetStyle"
											>Maximum Number Of Attempts&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="ptc-testconfiginputField pr-35"
											data-bs-trigger="hover focus"
											placeholder="Enter here"
											type="text"
											@keyup="changeconfig(), changemaxattempt()"
											@keypress="validateInput($event)"
											v-model.trim="
												$v.testConfigData.config.maxnoattempts.$model
											"
											:class="{
												error: $v.testConfigData.config.maxnoattempts.$error,
											}"
										></b-form-input>
										<b-popover
											target="attempt"
											triggers="hover"
											placement="bottom"
											customClass="attempt-warning-box"
										>
											<img
												src="../../assets/icons/Qpbuilder/warning.svg"
												alt=""
											/>
											As the start and end time & date duration is only
											applicable to a single attempt, you cannot select more
											than one maximum number of attempts.
										</b-popover>

										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.maxnoattempts.$dirty &&
													!$v.testConfigData.config.maxnoattempts.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.maxnoattempts.numeric &&
													$v.testConfigData.config.maxnoattempts.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Enter a valid number',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.maxnoattempts.between &&
													$v.testConfigData.config.maxnoattempts.numeric
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 1 to 10',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col>
									<div
										class="topDiv mt-3 relativeclass"
										v-if="$route.query.type != '4'"
									>
										<label class="testconfigfieldsetStyle"
											>Buffer Time (Minutes)&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="ptc-testconfiginputField pr-35"
											id="input-1"
											placeholder="Enter here"
											type="text"
											v-model.trim="$v.testConfigData.config.buffertime.$model"
											@keypress="validateInput($event)"
											:class="{
												error: $v.testConfigData.config.buffertime.$error,
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.buffertime.$dirty &&
													!$v.testConfigData.config.buffertime.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.buffertime.numeric &&
													$v.testConfigData.config.buffertime.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Enter a valid number',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.buffertime.between &&
													$v.testConfigData.config.buffertime.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 0 to 60',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>

							<b-row>
								<b-col>
									<label class="pt-testconfigfieldsetStyle sharelabel mt-2"
										>Time Between Attempts<span
											class="asterik"
											v-if="testConfigData.config.maxnoattempts > 1"
											>*</span
										></label
									>
								</b-col>
								<b-col>
									<label
										v-if="testConfigData.config.maxnoattempts > 1"
										class="pt-testconfigfieldsetStyle sharelabel mt-2"
										>Priority Attempt
									</label>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="2">
									<div
										class="ptc-parentDropdown topDiv position-relative ptc-question-behaviour"
										ref="timeBetweenAttemptsDropdown"
									>
										<div
											class="d-flex justify-content-between pointer"
											@click="
												testConfigData.config.maxnoattempts < 2
													? ''
													: (qbdropadd = !qbdropadd)
											"
											:class="
												$v.testConfigData.config.timebnsel.$error
													? 'ptc-error'
													: testConfigData.config.maxnoattempts < 2
													? 'ptc-selectTime'
													: 'ptc-dropdown-diffy'
											"
										>
											<span>{{
												testConfigData.config.timebnsel == "hrs"
													? "Hours"
													: testConfigData.config.timebnsel == "mins"
													? "Minutes"
													: testConfigData.config.timebnsel == "days"
													? "Days"
													: "Select"
											}}</span>
											<span>
												<img
													v-if="qbdropadd"
													src="../../assets/uparrow.svg"
													alt=""
													class="mr-1"
												/>
												<img
													v-else
													src="../../assets/downarrow.svg"
													alt=""
													class="mr-1"
												/>
											</span>
										</div>
										<div
											v-closable="{
												exclude: ['timeBetweenAttemptsDropdown'],
												handler: 'hidetimeBetweenAttemptsDropdown',
											}"
											v-if="qbdropadd"
											class="time-attempts-dropdown-option-add mt-1"
										>
											<b-form-group>
												<b-form-radio-group
													@change="qbdropadd = !qbdropadd"
													class="qb-add-drop width-full"
													id="btn-radios-3"
													v-model="$v.testConfigData.config.timebnsel.$model"
													:options="filteredTimeOptions"
													name="radio-btn-stacked"
													buttons
													stacked
												></b-form-radio-group>
											</b-form-group>
										</div>
										<div
											style="position: absolute; top: 1px; right: 25px"
											v-if="
												$v.testConfigData.config.timebnsel.$dirty &&
													!$v.testConfigData.config.timebnsel.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col cols="4">
									<div class="topDiv relativeclass ptc-question-behaviour">
										<b-form-input
											class="ptc-testconfiginputField pr-35"
											id="input-1"
											:placeholder="
												`${
													testConfigData.config.timebnsel == 'hrs'
														? 'Enter in hours'
														: testConfigData.config.timebnsel == 'mins'
														? 'Enter in minutes'
														: testConfigData.config.timebnsel == 'days'
														? 'Enter in days'
														: 'Enter time'
												}`
											"
											:disabled="
												testConfigData.config.maxnoattempts < 2 ||
													testConfigData.config.timebnsel == ''
											"
											:class="
												$v.testConfigData.config.timebnvalue.$error
													? 'error'
													: ''
											"
											type="text"
											@keyup="changeconfig()"
											@keypress="validateInput($event)"
											v-model="$v.testConfigData.config.timebnvalue.$model"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.timebnvalue.$dirty &&
													!$v.testConfigData.config.timebnvalue.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Required',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												testConfigData.config.timebnsel === 'hrs' &&
													!$v.testConfigData.config.timebnvalue.Validate &&
													$v.testConfigData.config.timebnvalue.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 1 to 24',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												testConfigData.config.timebnsel === 'mins' &&
													!$v.testConfigData.config.timebnvalue.Validate &&
													$v.testConfigData.config.timebnvalue.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be a whole number between 1 and 60.',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												testConfigData.config.timebnsel === 'days' &&
													!$v.testConfigData.config.timebnvalue.Validate &&
													$v.testConfigData.config.timebnvalue.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 1 to 365',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 1px; right: 25px"
											v-if="
												!$v.testConfigData.config.timebnvalue.numeric &&
													!$v.testConfigData.config.timebnvalue.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Invalid number',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col v-if="testConfigData.config.maxnoattempts > 1">
									<div class="d-flex align-items-center mt-2">
										<b-form-radio-group
											class="mcq-radiobtns radio-btn-label"
											:options="priorityoptions"
											v-model="testConfigData.config.priority"
											value-field="item"
											text-field="name"
											disabled-field="notEnabled"
											@change="changeconfig()"
											size="sm"
										></b-form-radio-group>
									</div>
								</b-col>
							</b-row>

							<b-row class="mt-3">
								<b-col class="ptc-checkBox" v-if="$route.query.type != '4'">
									<b-form-checkbox
										class="mt-3 checkbox testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										@change="changeconfig()"
										v-model="testConfigData.config.shuffle"
									>
										<div class="">Randomly Shuffle Questions</div>
									</b-form-checkbox>
								</b-col>
								<b-col class="ptc-checkBox" v-if="$route.query.type != '4'">
									<b-form-checkbox
										class="mt-3 checkbox testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="testConfigData.config.dispReqStatus"
										@change="changeconfig()"
									>
										<div class="">Display Mandatory Question Icon</div>
									</b-form-checkbox>
								</b-col>
								<b-col> </b-col>
							</b-row>
							<b-row>
								<b-col class="ptc-checkBox" v-if="$route.query.type != '4'">
									<b-form-checkbox
										class="mt-3 checkbox testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="testConfigData.config.displayReqFirst"
										@change="changeconfig()"
									>
										<div class="">Display Mandatory Questions First</div>
									</b-form-checkbox>
								</b-col>
								<b-col class="ptc-checkBox" v-if="$route.query.type != '4'">
									<b-form-checkbox
										class="mt-3 checkbox testconfig-checkbox"
										size="sm"
										name="checkbox-1"
										v-model="testConfigData.config.dispMarks"
										@change="changeconfig()"
									>
										<div class="">Display Marks For Every Question</div>
									</b-form-checkbox>
								</b-col>
								<b-col></b-col>
							</b-row>
						</div>

						<div class="mt-5 ptc-next">
							<b-button @click="questionbehaviour" class="addbtn pl-4 pr-4"
								>Next</b-button
							>
						</div>
						<div class="mt-5 ptc-undo">
							<div
								@click="$bvModal.show('confirm-undo')"
								v-if="configurechange"
								variant="outline"
								class="qb-add-more-matches pointer ml-3 pl-4 pr-4 mb-2"
							>
								undo changes
							</div>
						</div>
					</b-tab>
					<b-tab>
						<template #title>
							<div class="d-flex align-items-center position-relative">
								<div>System Setup</div>
								<div
									style="position: absolute; top: 0px; right: -21px"
									v-b-popover.hover.top.v-danger="{
										content: 'Please fill all the details',
									}"
									variant="primary"
								>
									<img
										v-if="
											$v.testConfigData.config.screenCapture.$error ||
												$v.testConfigData.config.communicationTestDuration
													.$error ||
												$v.testConfigData.config.communicationTestAttempts
													.$error ||
												(testConfigData.config.enableProctoring &&
													!testConfigData.config.enableCamera &&
													$v.testConfigData.config.passingPercentage.$dirty)
										"
										src="../../assets/deletepopupicon.svg"
										alt=""
									/>
								</div>
							</div>
						</template>
						<div class="ptc-question-behaviour">
							<b-row>
								<b-col cols="4">
									<div>
										<div class="ptc-checkBox">
											<b-form-checkbox
												class="mt-3 checkbox testconfig-checkbox"
												size="sm"
												name="checkbox-1"
												v-model="testConfigData.config.communicationTest"
												@change="resetFields()"
											>
												<div class="">Communication Test</div>
											</b-form-checkbox>
										</div>
										<div class="topDiv mt-3 relativeclass">
											<label class="ptc-testconfigfieldsetStyle"
												>Communication Test Attempts &nbsp;<span class="asterik"
													>*</span
												></label
											>
											<b-form-input
												class="ptc-testconfiginputField pr-35"
												id="input-1"
												placeholder="Enter here"
												:disabled="!testConfigData.config.communicationTest"
												type="text"
												@keyup="changeconfig()"
												@keypress="validateInput($event)"
												v-model.trim="
													$v.testConfigData.config.communicationTestAttempts
														.$model
												"
												:class="{
													error:
														$v.testConfigData.config.communicationTestAttempts
															.$error,
												}"
											></b-form-input>
											<div
												style="position: absolute; top: 2px; right: 12px"
												v-if="
													$v.testConfigData.config.communicationTestAttempts
														.$dirty &&
														!$v.testConfigData.config.communicationTestAttempts
															.required
												"
												v-b-popover.hover.top.v-danger="{ content: 'Required' }"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
											<div
												style="position: absolute; top: 2px; right: 12px"
												v-if="
													!$v.testConfigData.config.communicationTestAttempts
														.numeric &&
														$v.testConfigData.config.communicationTestAttempts
															.required
												"
												v-b-popover.hover.top.v-danger="{
													content: 'Enter a valid number',
												}"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
											<div
												style="position: absolute; top: 2px; right: 12px"
												v-if="
													!$v.testConfigData.config.communicationTestAttempts
														.between &&
														$v.testConfigData.config.communicationTestAttempts
															.numeric
												"
												v-b-popover.hover.top.v-danger="{
													content: 'Should be between 1 to 5',
												}"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
										</div>
										<div class="ptc-checkBox">
											<b-form-checkbox
												class="mt-3 checkbox testconfig-checkbox"
												size="sm"
												name="checkbox-1"
												v-model="testConfigData.config.enableProctoring"
												@change="resetFields()"
											>
												<div class="">Enable Video Proctoring</div>
											</b-form-checkbox>
										</div>
										<div class="topDiv mt-3 relativeclass">
											<label class="ptc-testconfigfieldsetStyle"
												>Set Image Capture Timing-Slot (Seconds) &nbsp;<span
													class="asterik"
													>*</span
												></label
											>
											<b-form-input
												class="ptc-testconfiginputField pr-35"
												id="input-1"
												:disabled="!testConfigData.config.enableProctoring"
												type="text"
												@keyup="changeconfig()"
												@keypress="validateInput($event)"
												v-model.trim="
													$v.testConfigData.config.screenCapture.$model
												"
												placeholder="Enter here"
												:class="{
													error: $v.testConfigData.config.screenCapture.$error,
												}"
											></b-form-input>
											<div
												style="position: absolute; top: 4px; right: 12px"
												v-if="
													$v.testConfigData.config.screenCapture.$dirty &&
														!$v.testConfigData.config.screenCapture.required
												"
												v-b-popover.hover.top.v-danger="{ content: 'Required' }"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
											<div
												style="position: absolute; top: 2px; right: 12px"
												v-if="
													!$v.testConfigData.config.screenCapture.numeric &&
														$v.testConfigData.config.screenCapture.required
												"
												v-b-popover.hover.top.v-danger="{
													content: 'Invalid number (decimal not allowed)',
												}"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
											<div
												style="position: absolute; top: 2px; right: 12px"
												v-if="
													!$v.testConfigData.config.screenCapture.between &&
														$v.testConfigData.config.screenCapture.required
												"
												v-b-popover.hover.top.v-danger="{
													content: 'Should be between 1 to 15',
												}"
												variant="primary"
											>
												<img src="../../assets/deletepopupicon.svg" alt="" />
											</div>
										</div>
										<div class="ptc-checkBox d-flex">
											<b-form-checkbox
												class="checkbox testconfig-checkbox mt-3"
												size="sm"
												name="checkbox-1"
												v-model="testConfigData.config.enableCamera"
												@change="
													selectdosanddonts(
														testConfigData.config.enableCamera,
														'enableCamera'
													),
														changeconfig()
												"
											>
												<div class="">Enable Video Recording</div>
											</b-form-checkbox>
											<img
												v-if="
													testConfigData.config.enableProctoring &&
														!testConfigData.config.enableCamera
												"
												src="../../assets/deletepopupicon.svg"
												alt=""
												class="mt-3 ml-1 mr-4"
												v-b-popover.hover.top.v-danger="{
													content:
														'Enable Video Recording since proctoring is enabled',
												}"
											/>
										</div>
									</div>
								</b-col>
								<b-col cols="8">
									<b-row>
										<b-col>
											<div class="ml-5 ptc-checkBox">
												<div class="mt-3">
													<b-form-checkbox
														class="checkbox testconfig-checkbox"
														size="sm"
														name="checkbox-1"
														v-model="
															testConfigData.config.allowImageAndIdCapture
														"
														@change="
															selectdosanddonts(
																testConfigData.config.allowImageAndIdCapture,
																'allowImageAndIdCapture'
															),
																changeconfig()
														"
													>
														<div class="">Allow Image And ID Capture</div>
													</b-form-checkbox>
												</div>
												<div class="mt-3" v-if="$route.query.type != '4'">
													<b-form-checkbox
														class="checkbox testconfig-checkbox"
														size="sm"
														name="checkbox-1"
														v-model="testConfigData.config.instantemail"
														@change="
															selectdosanddonts(
																testConfigData.config.instantemail,
																'instantemail'
															),
																changeconfig()
														"
													>
														<div class="">Instant Test Result</div>
													</b-form-checkbox>
												</div>
												<div>
													<b-form-checkbox
														class="mt-3 checkbox testconfig-checkbox"
														size="sm"
														name="checkbox-1"
														v-model="
															testConfigData.config.allowCandidateRemarks
														"
													>
														<div class="">Allow Candidate Feedback</div>
													</b-form-checkbox>
												</div>
												<div class="mt-3">
													<b-form-checkbox
														class="checkbox testconfig-checkbox"
														size="sm"
														name="checkbox-1"
														v-model="testConfigData.config.includeTimeNotifics"
														@change="changeconfig()"
													>
														<div class="">
															Include Time Sensitivity Notifications
														</div>
													</b-form-checkbox>
												</div>
												<div class="mt-3">
													<b-form-checkbox
														class="checkbox testconfig-checkbox"
														size="sm"
														name="checkbox-1"
														v-model="testConfigData.config.internetCheck"
														@change="changeconfig()"
													>
														<div class="">Enable Internet Check</div>
													</b-form-checkbox>
												</div>
												<div></div>
											</div>
										</b-col>
										<b-col>
											<div class="ml-5 ptc-checkBox">
												<div class="mt-3">
													<b-form-checkbox
														class="mt-3 checkbox testconfig-checkbox"
														size="sm"
														name="checkbox-1"
														v-model="testConfigData.config.typingTest"
													>
														<div class="">Typing Test</div>
													</b-form-checkbox>
												</div>
												<div>
													<b-form-checkbox
														class="mt-3 checkbox testconfig-checkbox"
														size="sm"
														name="checkbox-1"
														v-model="testConfigData.config.allowAgent"
														@change="
															selectdosanddonts(
																testConfigData.config.allowAgent,
																'allowAgent'
															),
																changeconfig()
														"
													>
														<div class="">Allow Agent</div>
													</b-form-checkbox>
												</div>
												<div v-if="$route.query.type != '4'">
													<b-form-checkbox
														class="mt-3 checkbox testconfig-checkbox"
														size="sm"
														name="checkbox-1"
														v-model="testConfigData.config.enableScreenShare"
													>
														<div class="">Enable Screen Share</div>
													</b-form-checkbox>
												</div>
												<div class="mt-3">
													<b-form-checkbox
														class="checkbox testconfig-checkbox"
														size="sm"
														name="checkbox-1"
														v-model="testConfigData.config.allowExtension"
														@change="
															selectdosanddonts(
																testConfigData.config.allowExtension,
																'allowExtension'
															),
																changeconfig()
														"
													>
														<div class="">Allow Extension</div>
													</b-form-checkbox>
												</div>
												<div class="mt-3">
													<b-form-checkbox
														class="checkbox testconfig-checkbox"
														size="sm"
														name="checkbox-1"
														v-model="testConfigData.config.allowLocation"
														@change="changeconfig()"
													>
														<div class="">Allow Location</div>
													</b-form-checkbox>
												</div>
											</div>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
						</div>
						<div class="mt-5 ptc-next">
							<b-button @click="systemsetup" class="addbtn pl-4 pr-4"
								>Next</b-button
							>
						</div>
						<div class="mt-5 ptc-undo">
							<div
								@click="$bvModal.show('confirm-undo')"
								v-if="configurechange"
								variant="outline"
								class="qb-add-more-matches pointer ml-3 pl-4 pr-4 mb-2"
							>
								undo changes
							</div>
						</div>
					</b-tab>
					<b-tab>
						<template #title>
							<div class="d-flex align-items-center position-relative">
								<div>Do’s and Dont’s</div>
								<div
									style="position: absolute; top: 0px; right: -21px"
									v-b-popover.hover.top.v-danger="{
										content: 'Please fill all the details',
									}"
									variant="primary"
								>
									<img
										v-if="$v.testConfigData.config.dosAndDonts.$error"
										src="../../assets/deletepopupicon.svg"
										alt=""
									/>
								</div>
							</div>
						</template>
						<div class="base">
							<div class="ptc-question-behaviour">
								<div class="testconfig-dondont">
									<draggable
										tag="div"
										group="trueexpdata"
										:list="testConfigData.config.dosAndDonts"
										class="pointer"
									>
										<div
											v-for="(i, index) in testConfigData.config.dosAndDonts"
											:key="index"
											class="mt-3"
										>
											<b-input-group>
												<div class="d-flex body-viewtrue-col">
													<div class="body-viewtrue-col topDiv">
														<label class="testconfigfieldsetStyle"
															>{{ index + 1 }}. Do's & Dont’s&nbsp;<span
																class="asterik"
																>*</span
															></label
														>
														<b-form-input
															autofocus
															class="ptc-testconfiginputField padding-class pointer"
															placeholder="Enter here"
															:class="{
																error:
																	$v.testConfigData.config.dosAndDonts.$each[
																		index
																	].$error,
															}"
															type="text"
															v-model="i.value"
															@keyup.enter="addOptions, changeconfig()"
														></b-form-input>
													</div>
													<div
														style="position: absolute; top: 4px; right: 10px"
														v-if="
															$v.testConfigData.config.dosAndDonts.$each[index]
																.$dirty &&
																!$v.testConfigData.config.dosAndDonts.$each[
																	index
																].value.required
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Required',
														}"
														variant="primary"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
														/>
													</div>
													<div
														style="position: absolute; top: 4px; right: 10px"
														v-if="
															!$v.testConfigData.config.dosAndDonts.$each[index]
																.value.maxLength &&
																$v.testConfigData.config.dosAndDonts.$each[
																	index
																].value.required
														"
														v-b-popover.hover.top.v-danger="{
															content: 'Should not exceed 256 characters',
														}"
														variant="primary"
													>
														<img
															src="../../assets/deletepopupicon.svg"
															alt=""
															class="blue-background"
														/>
													</div>
													<div
														class="relativeclass"
														v-if="testConfigData.config.dosAndDonts.length > 1"
													>
														<div class="ptc-testconfigdeleteicon pointer">
															<span @click="deleteOption(index)"
																><img
																	src="../../assets/deleteicon.svg"
																	alt=""
																	class="blue-background"
															/></span>
														</div>
													</div>
												</div>
											</b-input-group>
										</div>
									</draggable>
								</div>
								<div v-if="errorstatus" class="text-center">
									<span class="errorclass"
										>*please fill mandatory fields in all tabs</span
									>
								</div>
								<b-row class="">
									<b-col cols="" class=""> </b-col>
								</b-row>
							</div>

							<div class="ptc-next">
								<b-button
									@click="addOptions()"
									variant="outline"
									class="cursor-pointer p-2 mr-3"
								>
									<span
										><img src="../../assets/addicongraywhite.svg" alt=""
									/></span>
									<span class="ml-2 qb-add-more-matches">Add</span>
								</b-button>

								<b-button
									v-if="type == 'add'"
									@click="addConfig()"
									class="addbtn pl-4 pr-4"
									>Save</b-button
								>
							</div>
							<div class="mt-5 ptc-undo">
								<div
									@click="$bvModal.show('confirm-undo')"
									v-if="configurechange"
									variant="outline"
									class="qb-add-more-matches pointer ml-3 pl-4 pr-4 mb-2"
								>
									undo changes
								</div>
							</div>
						</div>
					</b-tab>
				</b-tabs>
			</div>
		</div>
		<div
			class="testconfig-rightcontainer d-flex align-items-center relativeclass"
		>
			<div class="testconfigimg">
				<img
					src="../../assets/icons/testconfig/testconfig.svg"
					alt=""
					width="100%"
				/>
			</div>
		</div>

		<b-modal
			id="confirm-undo"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div class="modalheading">Caution !</div>
			<div @click="$bvModal.hide('confirm-undo')" class="xMarkCancel">
				<img class="caution_symb" src="../../assets/caution.svg" alt="" />
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to undo all the changes?</span>
			</div>
			<div class="mt-2 caution-modal-text">
				You have unsaved data. On click of 'OK' changes made in all tabs will be
				discarded.
			</div>
			<div class="mt-2 normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button
					class="addbtn mr-2 pt-2 pb-2 pl-4 pr-4"
					@click="$bvModal.hide('confirm-undo'), undoChange()"
					>Ok</b-button
				>
				<div
					class="sec-canceltext pointer"
					@click="$bvModal.hide('confirm-undo')"
				>
					Cancel
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import QuillEditor from "../../components/forms/quillEditor.vue"; //Quill editor from component

import {
	required,
	maxLength,
	helpers,
	between,
	requiredIf,
	numeric,
} from "vuelidate/lib/validators";
import { getConfig, editConfig, addConfig } from "../../utils/apiFunctions.js";

import { mapGetters } from "vuex";
import toastFunction from "../mixin/toast";
import { dosanddontslist } from "../../utils/apiFunctions";
import draggable from "vuedraggable";
import { DateTime as LuxonDateTime } from "luxon";

const betweenTestDuration = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const type = urlParams.get("type");
	return type === "4" ? between(5, 1440) : between(5, 360);
};

const betweenBufferTime = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const type = urlParams.get("type");
	return type === "4" ? between(0, 1440) : between(0, 360);
};

export default {
	components: {
		draggable,
		QuillEditor,
	},
	mixins: [toastFunction],
	name: "ParticularTestConfiguration",
	data() {
		return {
			addques1: false,
			addques2: false,
			dirtyCheckDescQuestion: false,
			dirtyCheckQuestion: false,
			addtime: "",
			timeoptions: [
				{
					value: "mins",
					text: "Minutes",
				},
				{
					value: "hrs",
					text: "Hours",
				},
				{
					value: "days",
					text: "Days",
				},
			],
			qbdropadd: false,

			testinstruction: "not_accepted",
			configName: "",
			type: "add",
			groupType: "",
			tabIndex: 0,
			startDate: null,
			enDate: null,
			testInst: false,
			errorstatus: false,
			check: true,
			startdatetime: LuxonDateTime.local()
				.minus({ month: 0, days: 0 })
				.toISO(),
			LoaderStatus: false,
			configurechange: false,
			testConfigData: {
				config: {
					testOrg: "",
					testDesc: "",
					testInst: "",
					timebnsel: "",
					timebnvalue: "",
					dispDuration: true,
					dispCount: true,
					allowCandidateRemarks: false,
					quesPerScreen: "10",
					priority: "first",
					shuffle: false,
					dispReqStatus: false,
					displayReqFirst: false,
					dispMarks: false,
					test: "public",
					allowAgent: false,
					payment: false,
					allowImageAndIdCapture: false,
					allowExtension: false,
					allowLocation: false,
					enableScreenShare: false,
					negativeMarkValue: null,
					openTestdt: null,
					closeTestdt: null,
					passingPercentage: null,
					testDuration: 30,
					typingTest: false,
					enableProctoring: false,
					communicationTest: false,
					communicationTestDuration: 45,
					communicationTestAttempts: null,

					typingDuration: 60,
					includeTimeNotifics: false,
					enableCamera: false,
					includeEndTest: true,
					instantemail: false,
					maxnoattempts: 1,
					buffertime: null,
					timebetweenattempts: null,
					screenCapture: null,
					curDate: "",
					paymentDetails: {
						cost: null,
						certificate: false,
						training: false,
						badge: false,
						toLearn: "",
						skillsGain: "",
						about: "",
					},
					dosAndDonts: [
						{
							value: "",
						},
					],
				},
			},
			testoptions: [
				{
					item: "public",
					name: "Public",
				},
				{
					item: "private",
					name: "Private",
				},
			],
			priorityoptions: [
				{
					item: "first",
					name: "First Attempt",
				},
				{
					item: "last",
					name: "Last Attempt",
				},
				{
					item: "highestScored",
					name: "Highest Scored",
				},
			],
			options: [
				{
					item: true,
					name: "Yes",
				},
				{
					item: false,
					name: "No",
				},
			],
			editorConfig: {
				toolbar: ["Bold", "Italic", "-", "NumberedList", "BulletedList", "-"],
			},
		};
	},

	computed: {
		currentDateOpen() {
			return new Date().toISOString();
		},
		timeDiffMinutes() {
			if (
				this.testConfigData.config.openTestdt &&
				this.testConfigData.config.closeTestdt
			) {
				const startDate = new Date(this.testConfigData.config.openTestdt);
				const endDate = new Date(this.testConfigData.config.closeTestdt);
				const timeDiff = endDate.getTime() - startDate.getTime();

				if (this.testConfigData.config.testDuration !== null) {
					return (
						this.testConfigData.config.testDuration >
						Math.floor(timeDiff / (1000 * 60))
					);
				}
				return false;
			}
			return null;
		},


		hoursDiffAttempts() {
			if (
				this.testConfigData.config.openTestdt &&
				this.testConfigData.config.closeTestdt
			) {
				const startDate = new Date(this.testConfigData.config.openTestdt);
				const endDate = new Date(this.testConfigData.config.closeTestdt);
				const timeDiff = endDate.getTime() - startDate.getTime();

				if (this.testConfigData.config.testDuration !== null) {
					const hoursDiff = timeDiff / (1000 * 60 * 60);
					return hoursDiff > 24;
				}
				return false;
			}

			return null;
		},
		minutesDiffAttempts() {
			if (
				this.testConfigData.config.openTestdt &&
				this.testConfigData.config.closeTestdt
			) {
				const startDate = new Date(this.testConfigData.config.openTestdt);
				const endDate = new Date(this.testConfigData.config.closeTestdt);
				const timeDiffInMilliseconds = endDate.getTime() - startDate.getTime();
				const timeDiffInHours = timeDiffInMilliseconds / (1000 * 60 * 60);

				if (this.testConfigData.config.testDuration !== null) {
					return timeDiffInHours > 1;
				}
				return false;
			}

			return null;
		},
		filteredTimeOptions() {
			const showHours = this.minutesDiffAttempts;
			const showDays = this.hoursDiffAttempts;
			return this.timeoptions.filter(
				(option) =>
					(option.value !== "hrs" || showHours) &&
					(option.value !== "days" || showDays)
			);
		},

		currentDate: {
			// getter
			get: function() {
				if (
					this.testConfigData.config.closeTestdt <
					this.testConfigData.config.openTestdt
				) {
					return this.testConfigData.config.openTestdt;
				}
				return this.testConfigData.config.closeTestdt;
			},
			// setter
			set: function(newValue) {
				this.testConfigData.config.closeTestdt = newValue;
			},
		},

		minDate() {
			return this.testConfigData.config.openTestdt;
		},
		...mapGetters("sectionVUEX", {
			sectionDetails: "getSectionDetails",
		}),
		...mapGetters("topicVUEX", {
			selectedTopic: "getSelectedTopic",
		}),
	},

	validations() {
		return {
			configName: {
				required,
				maxLength: maxLength(128),
			},
			testConfigData: {
				name: {
					required,
					maxLength: maxLength(128),
				},
				config: {
					testOrg: {
						required,
						maxLength: maxLength(128),
					},
					testDesc: {
						required,
						maxLength: maxLength(100024),
					},
					quesPerScreen: {
						required: requiredIf(function() {
							return this.$route.query.type != "4";
						}),
						between: between(1, 10),
						numeric,
					},
					negativeMarkValue: {
						required: requiredIf(function() {
							return this.$route.query.type != "4";
						}),
						between: between(0, 30),
						numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
					},
					passingPercentage: {
						required,
						between: between(1, 100),
						numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
					},
					testDuration: {
						required,
						between: betweenTestDuration(),
						alpha: helpers.regex("alpha", /^\d{1,4}\.?\d{0,2}$/i),
					},

					openTestdt: {
						required,
					},
					closeTestdt: {
						required,
					},
					dosAndDonts: {
						$each: {
							value: {
								required,
								maxLength: maxLength(256),
							},
						},
					},
					paymentDetails: {
						cost: {
							required: requiredIf(function() {
								return this.testConfigData.config.payment;
							}),
						},
						about: {
							required: requiredIf(function() {
								return this.testConfigData.config.payment;
							}),
						},
						skillsGain: {
							required: requiredIf(function() {
								return this.testConfigData.config.payment;
							}),
						},
						toLearn: {
							required: requiredIf(function() {
								return this.testConfigData.config.payment;
							}),
						},
					},
					maxnoattempts: {
						required,
						numeric,
						between: between(1, 10),
					},
					buffertime: {
						required: requiredIf(function() {
							return this.$route.query.type != "4";
						}),
						between: betweenBufferTime(),
						numeric: helpers.regex("numeric", /^\d{1,4}\.?\d{0,2}$/),
					},
					timebnvalue: {
						required: requiredIf(function() {
							return (
								this.testConfigData.config.maxnoattempts >= 2 &&
								this.testConfigData.config.timebnsel != ""
							);
						}),
						Validate: this.validateTime,
						numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
					},
					timebnsel: {
						required: requiredIf(function() {
							return this.testConfigData.config.maxnoattempts >= 2;
						}),
					},

					screenCapture: {
						required: requiredIf(function() {
							return this.testConfigData.config.enableProctoring;
						}),
						numeric,
						between: between(1, 15),
					},

					communicationTestDuration: {
						required: requiredIf(function() {
							return this.testConfigData.config.communicationTest;
						}),
						between: between(30, 360),
					},
					communicationTestAttempts: {
						required: requiredIf(function() {
							return this.testConfigData.config.communicationTest;
						}),
						between: between(1, 5),
						numeric,
					},
				},
			},
		};
		// }
	},
	created() {
		this.LoaderStatus = true;
		setTimeout(() => {
			this.LoaderStatus = false;
		}, 500);
		if (this.$route.query.configID) {
			this.type = "edit";
			this.getConfig();
		}
		this.getdosanddonts();

		this.curDate = this.currentDateOpen;
		if (this.$route.params.groupType) {
			this.groupType = this.$route.params.groupType;
		} else if (this.$route.query.groupType) {
			this.groupType = this.$route.query.groupType;
		}
		if (this.groupType == "I") {
			this.testConfigData.config.test = "private";
		}
	},
	methods: {
		validateText(val) {
			this.dirtyCheckDescQuestion = val;
		},
		updateQuestionContent(newContent) {
			this.testConfigData.config.testDesc = newContent;
		},
		changedaddQues(newval) {
			this.addques1 = newval;
		},

		validateText2(val) {
			this.dirtyCheckQuestion = val;
		},
		updateQuestionContent2(newContent) {
			this.testConfigData.config.testInst = newContent;
		},
		changedaddQues2(newval) {
			this.addques2 = newval;
		},
		validateInput(event) {
			const charCode = event.keyCode || event.which;
			const charTyped = String.fromCharCode(charCode);
			// Regular expression to allow only numbers and a single dot
			const regex = /^(?!0{2,})\d{1,4}(?:\.\d{0,2})?$/;
			// If the typed character is not a number or dot, prevent the default behavior
			if (!regex.test(event.target.value + charTyped)) {
				event.preventDefault();
			}
		},
		getDesiredContent(contentType) {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML =
				contentType === "testDesc" ? this.testConfigData.config.testDesc : "";
			const pTags = tempDiv.querySelectorAll("p");

			let endIndex = pTags.length;

			for (let i = pTags.length - 1; i >= 0; i--) {
				if (this.isBetweenContentTag(pTags[i])) {
					endIndex = i + 1;
					break;
				}
			}

			pTags.forEach((pTag, index) => {
				if (index >= endIndex && !pTag.textContent.trim()) {
					tempDiv.removeChild(pTag);
				}
			});

			if (contentType === "testDesc") {
				this.testConfigData.config.testDesc = tempDiv.innerHTML;
			} else if (contentType === "testInst") {
				this.testConfigData.config.testInst = tempDiv.innerHTML;
			}
		},

		isBetweenContentTag(element) {
			return element.textContent.trim() !== "";
		},

		hidetimeBetweenAttemptsDropdown() {
			this.qbdropadd = false;
		},
		closeSelectOption(option) {
			if (this.testConfigData.config.timebnsel === option.value) {
				this.qbdropadd = false;
			} else {
				this.testConfigData.config.timebnsel = option.value;
			}
		},
		validateTime() {
			if (this.testConfigData.config.maxnoattempts > 1) {
				if (
					this.testConfigData.config.timebnsel === "hrs" &&
					this.testConfigData.config.timebnvalue > 0 &&
					this.testConfigData.config.timebnvalue <= 24
				) {
					return true;
				} else if (
					this.testConfigData.config.timebnsel === "mins" &&
					this.testConfigData.config.timebnvalue >= 1 &&
					this.testConfigData.config.timebnvalue <= 60 && 
					this.testConfigData.config.timebnvalue % 1 === 0
				) {
					return true;
				} else if (
					this.testConfigData.config.timebnsel === "days" &&
					this.testConfigData.config.timebnvalue >= 1 &&
					this.testConfigData.config.timebnvalue <= 365
				) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		},
		changemaxattempt() {
			if (this.testConfigData.config.maxnoattempts < 2) {
				this.testConfigData.config.timebetweenattempts = null;
				this.testConfigData.config.timebnvalue = "";
				this.testConfigData.config.timebnsel = "";
			}
		},
		getTodayDate() {
			let date = new Date();
			let year = date.getFullYear();
			let month = date.getMonth() + 1;
			if (month < 10) {
				month = 0 + "" + month;
			}
			let day = date.getDate();
			return year + "-" + month + "-" + day;
		},
		goToConfig() {
			console.log(this.$route.name, "this.$route.name");
			if (
				this.$route.name == "addconfigsandbox" ||
				this.$route.query.type == "4"
			) {
				this.$router.push({
					name: "configuresandbox",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						groupID: this.$route.params.groupID,
						groupType: this.groupType,
					},
					query: {
						testqp: this.$route.query.testqp,
						type: this.$route.query.type,
					},
				});
			} else if (this.$route.name == "ParticularTestConfigurationTest") {
				this.$router.push({
					path: `/configure/${this.$route.params.testID}/${this.$route.params.topicID}/${this.$route.params.groupID}/${this.groupType}`,
				});
			} else if (
				this.$route.name == "ParticularTestConfigurationAutogenerate"
			) {
				this.$router.push({
					name: "ConfigureAutogenerate",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						groupID: this.$route.params.groupID,
						testName: this.$route.params.testName,
						groupType: this.groupType,
					},
				});
			} else if (
				this.$route.name == "ParticularTestConfigurationAutoQPBuilder"
			) {
				this.$router.push({
					name: "ConfigureAutoQPBuilder",
					params: {
						testID: this.$route.params.testID,
						topicID: this.$route.params.topicID,
						groupID: this.$route.params.groupID,
						testName: this.$route.params.testName,
						groupType: this.groupType,
					},
				});
			} else {
				const { testID, topicID, groupID, groupType } = this.$route.params;
				const { testqp, autoqp } = this.$route.query;

				let queryParams = {};

				if (testqp) {
					queryParams = { testqp };
				} else if (autoqp) {
					queryParams = { autoqp };
				}

				if (testqp || autoqp) {
					this.$router.push({
						path: `/share/configure/${testID}/${topicID}/${groupID}/${groupType}`,
						query: queryParams,
					});
				}
			}
		},
		async getdosanddonts() {
			try {
				const res = await dosanddontslist();
				if (res.status == 200) {
					let data = res.data.data;
					for (let i in data) {
						if (data[i].type == "Dos and Donts") {
							this.defaultdosanddonts = data[i].codeList;
						}
					}
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		undoChange() {
			if (this.type == "edit") {
				this.getConfig();
			} else {
				this.configName = "";
				this.testConfigData.config = {
					texteditablename: false,
					testOrg: "",
					testDesc: "",
					testInst: "",
					dispRealdt: false,
					dispDuration: true,
					dispCount: true,
					allowCandidateRemarks: false,
					autoCorrection: true,
					passingPercentage: null,
					quesPerScreen: "10",
					topic: "The Topic Name(Non-Editable)",
					sectionnum: "The No. of sections(Non-Editable)",
					shuffle: false,
					dispReqStatus: false,
					displayReqFirst: false,
					dispMarks: false,
					test: "public",
					priority: "first",
					allowAgent: false,
					allowImageAndIdCapture: false,
					allowExtension: false,
					allowLocation: false,
					includeTimer: false,
					negativeAutoCorrect: false,
					negativeMarkValue: null,
					openTestdt: null,
					closeTestdt: null,
					testDuration: 30,
					typingTest: false,
					enableProctoring: false,
					typingDuration: 60,
					screenCapture: null,
					includeTimeNotifics: false,
					internetCheck: false,
					enableCamera: false,
					includeEndTest: true,
					instantemail: false,
					maxnoattempts: 1,
					communicationTestAttempts: null,
					communicationTestDuration: 45,
					buffertime: null,
					timebetweenattempts: null,
					options: [
						{
							item: true,
							name: "Yes",
						},
						{
							item: false,
							name: "No",
						},
					],
					monitoringType: false,
					dosAndDonts: [
						{
							value: "",
						},
					],
				};
				this.$v.$reset();
				this.dirtyCheckDescQuestion = false;
				this.configurechange = false;
			}
		},
		selectdosanddonts(value, id) {
			if (value) {
				if (
					this.testConfigData.config.dosAndDonts.length > 0 &&
					this.testConfigData.config.dosAndDonts[0].value == ""
				) {
					this.testConfigData.config.dosAndDonts.splice(0, 1);
				}

				const defaultDosAndDonts = this.defaultdosanddonts.filter(
					(item) => item.value === id
				);
				defaultDosAndDonts.forEach((item) => {
					this.testConfigData.config.dosAndDonts.push({
						value: item.description,
						code: item.value,
					});
				});
			} else {
				const filteredDosAndDonts = this.testConfigData.config.dosAndDonts.filter(
					(item) => item.code !== id
				);
				this.testConfigData.config.dosAndDonts =
					filteredDosAndDonts.length > 0
						? filteredDosAndDonts
						: [{ value: "", code: "" }];
			}
		},

		routeBack() {
			if (this.$route.query.testqp) {
				let query = {
					testqp: this.$route.query.testqp,
				};
				if (this.$route.query.type == "4") {
					Object.assign(query, {
						type: 4,
					});
				}
				this.$router.push({
					path: `/share/configure/${this.$route.params.testID}/${this.$route.params.topicID}/${this.$route.params.topicID}/${this.groupType}`,
					query: query,
				});
			} else if (this.$route.query.autoqp) {
				this.$router.push({
					path: `/share/configure/${this.$route.params.testID}/${this.$route.params.topicID}/${this.$route.params.topicID}/${this.groupType}`,
					query: {
						autoqp: this.$route.query.autoqp,
					},
				});
			}
		},
		changeconfig() {
			this.configurechange = true;
		},
		focusOnStartDate() {
			this.$refs.startDate.$el.children[0].click();
		},
		focusOnEndDate() {
			if (this.testConfigData.config.openTestdt.length > 0)
				this.$refs.endDate.$el.children[0].click();
		},

		async getConfig() {
			try {
				const res = await getConfig(this.$route.query.configID);
				this.testConfigData = res.data.data;
				this.testConfigData.config.typingDuration = 60;
				this.configName = res.data.data.configName;
			} catch (error) {
				throw new Error(`Getting Test Config Failed! status: ${error.status}`);
			}
		},
		async addConfig() {
			this.addconfigvalid();
			this.$v.testConfigData.config.$touch();
			this.$v.configName.$touch();

			try {
				if (
					!this.dirtyCheckDescQuestion &&
					!this.$v.configName.$invalid &&
					!this.$v.testConfigData.config.$invalid
				) {
					this.errorstatus = false;
					this.addconfigtime();
					this.getDesiredContent("testDesc");
					this.getDesiredContent("testInst");
					let payload = {
						portion: "Config",
						testID: this.$route.params.testID,
						name: this.configName,
						groupID: this.$route.params.groupID,
						config: this.testConfigData.config,
					};
					if (this.$route.query.type == "4") {
						payload.config.dispCount = false;
						payload.config.quesPerScreen = "1";
						payload.config.shuffle = false;
						payload.config.dispReqStatus = false;
						payload.config.displayReqFirst = false;
						payload.config.dispMarks = true;
						payload.config.negativeMarkValue = "0";
						payload.config.buffertime = payload.config.testDuration;
						payload.config.enableScreenShare = false;
						payload.config.communicationTestDuration = "45";
						payload.config.typingDuration = "60";
						payload.config.includeEndTest = true;
						payload.config.instantemail = false;
						payload.config["configType"] = "sandbox";
					}
					const res = await addConfig(payload);
					if (res.status == 200) {
						this.goToConfig();
						this.$nextTick(() => {
							this.successToast("New configuration created successfully");
						});
						this.addques1 = true;
						this.addques2 = true;
						this.dirtyCheckDescQuestion = false;
						this.dirtyCheckQuestion = false;
					} else if (res.status == 409) {
						this.errorToast("Config name already exists");
						this.$bvModal.hide("confirm-edit");
					} else if (res.status == 400) {
						this.errorToast(res.data.data.Data);
					}
				} else {
					this.errorstatus = true;
					if (this.testinstruction == "not_accepted") {
						this.dirtyCheckQuestion = false;
						if (
							this.$v.testConfigData.config.testDesc.$invalid ||
							this.dirtyCheckDescQuestion
						) {
							this.dirtyCheckDescQuestion = true;
						}
					}
				}
			} catch (error) {
				this.errorToast(error.response.data.data.Data);
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		addconfigvalid() {
			if (!this.testConfigData.config.dispCount) {
				this.testConfigData.config.dispCount = true;
			}
			if (!this.testConfigData.config.dispDuration) {
				this.testConfigData.config.dispDuration = true;
			}
			if (!this.testConfigData.config.includeEndTest) {
				this.testConfigData.config.includeEndTest = true;
			}
		},
		addconfigtime() {
			if (this.testConfigData.config.timebnsel == "hrs") {
				this.testConfigData.config.timebetweenattempts =
					this.testConfigData.config.timebnvalue * 60;
			} else if (this.testConfigData.config.timebnsel == "days") {
				this.testConfigData.config.timebetweenattempts =
					this.testConfigData.config.timebnvalue * 1440;
			} else {
				this.testConfigData.config.timebetweenattempts = this.testConfigData.config.timebnvalue;
			}
		},
		confirm() {
			this.check = false;
			this.saveConfig();
		},
		addOptions() {
			this.testConfigData.config.dosAndDonts.push({
				value: "",
			});
		},
		resetFields() {
			if (!this.testConfigData.config.enableProctoring) {
				this.testConfigData.config.screenCapture = null;
			}
			if (!this.testConfigData.config.communicationTest) {
				this.testConfigData.config.communicationTestAttempts = null;
			}
		},
		deleteOption(i) {
			this.testConfigData.config.dosAndDonts.splice(i, 1);
		},
		async saveConfig() {
			try {
				this.$v.$touch();
				if (
					!this.$v.testConfigData.config.$invalid &&
					!(
						this.testConfigData.config.enableProctoring &&
						!this.testConfigData.config.enableCamera
					)
				) {
					let payload = {
						configID: this.$route.query.configID,
						config: {
							...this.testConfigData.config,
							buffertime: this.testConfigData.config.testDuration,
						},
						name: this.configName,
						check: this.check,
					};

					const res = await editConfig(payload);

					if (res.status == 200) {
						this.goToConfig();
						this.$nextTick(() => {
							this.successToast("Configuration updated successfully");
						});
					} else if (res.status == 409) {
						this.$bvModal.show("confirm-edit");
					}
					this.errorstatus = false;
				} else {
					this.errorstatus = true;
				}
			} catch (error) {
				if (error.response.status == 409) {
					this.$bvModal.show("confirm-edit");
				} else {
					this.errorToast(error.response.data.data.Details);
				}
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		questionbehaviour() {
			this.$v.testConfigData.config.passingPercentage.$touch();
			this.$v.testConfigData.config.negativeMarkValue.$touch();
			this.$v.testConfigData.config.maxnoattempts.$touch();
			this.$v.testConfigData.config.buffertime.$touch();
			this.$v.testConfigData.config.timebnvalue.$touch();
			this.$v.testConfigData.config.timebnsel.$touch();
			this.$v.testConfigData.config.quesPerScreen.$touch();
			this.$v.testConfigData.config.testDuration.$touch();
			this.$v.testConfigData.config.openTestdt.$touch();
			this.$v.testConfigData.config.closeTestdt.$touch();

			if (
				!this.$v.testConfigData.config.passingPercentage.$invalid &&
				!this.$v.testConfigData.config.maxnoattempts.$invalid &&
				!this.$v.testConfigData.config.timebnsel.$invalid &&
				!this.$v.testConfigData.config.timebnvalue.$invalid &&
				!this.$v.testConfigData.config.testDuration.$invalid &&
				!this.$v.testConfigData.config.openTestdt.$invalid &&
				!this.$v.testConfigData.config.closeTestdt.$invalid &&
				!this.$v.testConfigData.config.quesPerScreen.$invalid &&
				!this.$v.testConfigData.config.buffertime.$invalid &&
				!this.$v.testConfigData.config.negativeMarkValue.$invalid &&
				!this.timeDiffMinutes
			) {
				this.tabIndex++;
				this.$forceUpdate();
			}
		},
		openscreeen() {
			if (this.testinstruction == "not_accepted") {
				this.$v.testConfigData.config.testDesc.$touch();
				this.$v.testConfigData.config.testOrg.$touch();
				this.$v.configName.$touch();
				if (
					!this.dirtyCheckDescQuestion &&
					!this.$v.testConfigData.config.testOrg.$invalid &&
					!this.$v.testConfigData.config.testDesc.$invalid &&
					!this.$v.configName.$invalid
				) {
					this.tabIndex++;
					this.$forceUpdate();
				}

				if (
					this.$v.testConfigData.config.testDesc.$invalid ||
					this.dirtyCheckDescQuestion
				) {
					this.dirtyCheckDescQuestion = true;
				}
			}
		},

		systemsetup() {
			this.$v.testConfigData.config.screenCapture.$touch();
			this.$v.testConfigData.config.communicationTestDuration.$touch();
			this.$v.testConfigData.config.communicationTestAttempts.$touch();

			if (
				!this.$v.testConfigData.config.screenCapture.$invalid &&
				!this.$v.testConfigData.config.communicationTestDuration.$invalid &&
				!this.$v.testConfigData.config.communicationTestAttempts.$invalid
			) {
				if (this.testConfigData.config.enableProctoring) {
					if (this.testConfigData.config.enableCamera) {
						this.tabIndex++;
						this.$forceUpdate();
					}
				} else {
					this.tabIndex++;
					this.$forceUpdate();
				}
			}
		},
		payment() {
			this.$v.testConfigData.config.paymentDetails.$touch();
			if (!this.$v.testConfigData.config.paymentDetails.$invalid) {
				this.tabIndex++;
			}
		},
	},
};
</script>

<style>
.fordatetime input {
	overflow: visible;
	background: none;
	border: none;
	color: #72737e;
	font-size: 14px;
	padding: 5px 0;
	width: 100%;
}

.calender-image {
	position: absolute;
	top: 2px;
	right: 5px;
}

.tab-content {
	margin: 5px;
}

.padding-class {
	padding-right: 55px;
}

.radio-btn-label {
	font-weight: 400;
	font-size: 10px;
	color: #72738e;
}

.radio-btn-label-14 {
	font-weight: 400;
	color: #72738e;
}

.ptc-undo {
	left: -7px;
	position: absolute;
	bottom: 10px;
}

.ptc-next {
	right: 20px;
	position: absolute;
	bottom: 10px;
}

.topDiv .form-control.error:focus {
	border: 1px solid red !important;
	font-size: 14px !important;
}

.ptc-testconfiginputField {
	background: #f4f4f4;
	border: 1px solid rgba(10, 86, 200, 0.5);
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	font-size: 14px;
	color: #72737e;
	z-index: 5;
	padding-right: 30px;
	padding-left: 6px;
}

.ptc-checkBox
	.custom-checkbox.b-custom-control-sm
	.custom-control-label::before,
.input-group-sm .custom-checkbox .custom-control-label::before {
	top: 0.21875rem;
	left: -1.3125rem;
	width: 0.875rem;
	height: 0.875rem;
	background: #ffffff;
	border: 0.2px solid #adaaaa;
	box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.34);
	border-radius: 2px;
}

.ptc-checkBox-1
	.custom-checkbox.b-custom-control-sm
	.custom-control-label::before,
.input-group-sm .custom-checkbox .custom-control-label::before {
	top: 0.21875rem;
	left: -1.3125rem;
	width: 0.875rem;
	height: 0.875rem;
	border-radius: 0.2rem;
}

.ptc-testconfigfieldsetStyle {
	color: var(--bg-tertiary);
	background: #f4f4f4;

	position: absolute;
	left: 0.5vw;
	top: -9px;
	font-size: var(--size-10);
	line-height: 18px;
	z-index: 5;
	padding-left: 6px;
	padding-right: 4px;
}

.pt-testconfigfieldsetStyle {
	color: var(--bg-tertiary);
	font-size: var(--size-10);
	line-height: 18px;
}

.ptc-diffy {
	background: #f4f4f3;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
}

.ptc-time-drop-down {
	background: #ffffff;
	border: 0.2px solid #8a8b8c;
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
	border-radius: 5px;
	position: absolute;
	z-index: 5;
	width: 100%;
}

.ptc-dropdown-diffy {
	background: #f4f4f3;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	font-weight: 400;
	font-size: 13px;
	line-height: 20px;
	color: #72738e;
	padding: 6px;
}

.ckeditor
	.cke_chrome
	.cke_inner
	.cke_contents
	.cke_wysiwyg_frame
	.cke_editable {
	background: #0a56c8 !important;
}

.ptc-tabs-overflow {
	height: calc(100vh - 280px);
	overflow: auto;
	overflow-x: hidden;
}

.custom-control-label {
	cursor: pointer;
}

.ptc-checkBox label {
	color: var(--bg-tertiary);
}

.ptc-disable-class .btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
	background: #72738e;
}

.ptc-selectTime {
	background-color: #c2c2c2;
	opacity: 0.3;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	font-weight: 400;
	font-size: 13px;
	line-height: 20px;
	color: #675c5c;
	padding: 6px;
}

.ptc-testconfigdeleteicon {
	position: absolute;
	right: 13px;
	top: 2px;
}

.ckeditor a.cke_button {
	border: 1px solid transparent;
}

.ckeditor a.cke_button_off:hover,
a.cke_button_off:focus,
a.cke_button_off:active {
	padding: 4px 6px;
}

.ckeditor a.cke_button_on {
	background: #fff;
	border: 1px #bcbcbc solid;
	padding: 4px 6px;
}

.ptc-testconfig-maincontainer {
	position: relative;
	top: 70px;
	height: calc(100vh - 85px);
	overflow: hidden;
	padding-left: 40px;
}

.cke_bottom {
	display: none !important;
}

.cke_chrome {
	display: block;
	background: #fdfdfd;
	border: 0.7px solid rgba(10, 86, 200, 0.5) !important;
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25) !important;
	border-radius: 3px !important;
	padding: 0;
}

.cke_inner {
	display: block;
	background: #fdfdfd !important;
	height: 155px !important;
	padding: 0;
	-webkit-touch-callout: none;
	border-radius: 5px !important;
}

.cke_contents {
	display: block;
	height: 110px !important;
	overflow: hidden;
}

.cke_top {
	border-bottom: 1px solid #ececec !important;
	background: #f8f8f8;
	padding: 6px 8px 2px;
	white-space: normal;
	border-radius: 3px !important;
}

.cke_wysiwyg_frame,
.cke_wysiwyg_div {
	background-color: #fff;
	border-radius: 3px !important;
}

.cke_reset {
	margin: 0;
	padding: 0;
	border: 0;
	background: transparent;
	text-decoration: none;
	width: auto;
	height: auto;
	vertical-align: baseline;
	box-sizing: content-box;
	position: static;
	transition: none;
}

.cke_editable {
	background: #811717;
}

a.cke_button {
	border: 1px solid transparent;
}

a.cke_button_off:hover,
a.cke_button_off:focus,
a.cke_button_off:active {
	padding: 4px 6px;
}

a.cke_button_on {
	background: #fff;
	border: 1px #bcbcbc solid;
	padding: 4px 6px;
}

.ptc-parentDropdown .btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
	color: white !important;
}

#individual-popover {
	top: 58px !important;
	left: -190px !important;
}

#individual-popover .arrow {
	top: -13px !important;
	left: 15px !important;
}
</style>
<style scoped>
.ptc-question-behaviour .form-control:disabled,
.form-control[readonly] {
	background-color: #b8b8b8;
	opacity: 0.3;
	color: #000000;
}

/* time-between attempts radio buttons changed to div so that once the option is selected if we select it again then the div should get closed. */
.time-attempts-dropdown-option-add {
	background: #ffffff;
	border: 0.2px solid #8a8b8c;
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
	border-radius: 5px;
	font-size: var(--size-13);
	color: #545454;
	position: absolute;
	width: 100%;
	z-index: 2;
}

.time-attempt-dropdown > .time-attempt-child-dropdown:nth-child(2n) {
	background: #fdfdfd;
	color: #545454;
	text-align: left;
	border: none;
	border-radius: 4px;
}

.time-attempt-dropdown > .time-attempt-child-dropdown:nth-child(2n-1) {
	background: #f4f4f4;
	color: #545454;
	text-align: left;
	border: none;
	border-radius: 4px;
}

.selected-option-color {
	background: #72738e;
	color: white;
	text-align: left;
	border: none;
	border-radius: 4px;
}
.caution_symb {
	right: 23px;
	position: absolute;
	top: 28px;
}
</style>
